$(function(){
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
  $(document).on("click", ".option-type-color", function(){
    $(".cpb-category-title").each(function() {
      var $title = $(this).find("span").text();
      $(this).next(".cpb-category-content").attr("data-id",$title);
    });
    var $this = $(this);
    var $color = $(this).find("i").text();
    var $now = $(".cpb-category-content[data-id='乗り物']").find(".cpb-active").find(".cpb-option-label").text().split( ' - ' )[0];
    setTimeout(function(){
      $(".cpb-category-content[data-id='乗り物']").find(".cpb-option-label:contains('"+ $now +"')").parents(".cpb-option-type-img").click();
    }, 100);
  });
  $(document).on("click", ".option-type-select,.react-tabs__tab", function(){
    $(".cpb-category-title").each(function() {
      var $title = $(this).find("span").text();
      $(this).next(".cpb-category-content").attr("data-id",$title);
    });
  });
  $(document).on("click", "[data-id='犬種（裏面）'] .cpb-option div:nth-child(2)", function(){
    setTimeout(function(){
      $("[data-id='毛色（裏面）'] .cpb-option__wrapper").find(".option:nth-child(1) > .cpb-option").click();
    },1000);
  });
  //$(document).on("click", ".cpb-panels-tabs-button,.cpb-next-tab-button", function(){
  //  if( $(".cpb-preview-aside").is(':visible') ){
  //    setTimeout(function(){
  //      var pos = $("#product-builder").offset().top - $("header").outerHeight();
  //      $("html, body").animate({scrollTop:pos}, 500);
  //    },50);
  //  }
  //});
  $(document).on("click",".cpb-increment", function(){
    if($(this).siblings("input").val() > 0){
      $(this).parents(".cpb-counter").addClass('active');
    }
    else{
      $(this).parents(".cpb-counter").removeClass('active');
    }
  });
  $(document).on("click",".cpb-add-to-cart-button", function(){
    var pos = $("#product-builder").offset().top;
    $("html, body").animate({scrollTop:pos}, 500);
  });
  // #で始まるアンカーをクリックした場合に処理
  $(document).on( "click", 'a[href^="#"]', function() {
    var headerH = $('header').outerHeight();
    var position;
    if(!$(this).hasClass('noSmooth')){
      // スクロールの速度
      var speed = 1000; // ミリ秒
      // アンカーの値取得
      var href= $(this).attr("href");
      // 移動先を取得
      var target = $(href === "#" || href === "" ? 'html' : href);
      // 移動先を数値で取得 
      if( $(window).width() > 700 ){
        position = target.offset().top;
      }
      else{
        position = target.offset().top - headerH;
      }
      // スムーススクロール
      $('body,html').animate({scrollTop:position}, speed);
      return false;
    }
  });
});